import { createSlice } from '@reduxjs/toolkit';

// Helper function to load partner cart from localStorage
const loadPartnerCartFromStorage = () => {
  try {
    const cart = localStorage.getItem('partnerCart');
    return cart ? JSON.parse(cart) : [];
  } catch (error) {
    console.error('Error loading partner cart from localStorage:', error);
    return [];
  }
};

// Helper function to save partner cart to localStorage
const savePartnerCartToStorage = (cartItems) => {
  try {
    localStorage.setItem('partnerCart', JSON.stringify(cartItems));
  } catch (error) {
    console.error('Error saving partner cart to localStorage:', error);
  }
};

const partnerCartSlice = createSlice({
  name: 'partnerCart',
  initialState: {
    cartItems: loadPartnerCartFromStorage(),
  },
  reducers: {
    addToPartnerCart: (state, action) => {
      const item = action.payload;
      if (Array.isArray(item)) {
        state.cartItems = item;
      } else {
        if (!item) {
          return;
        }
        const alreadyInCart = state.cartItems.some(ci => ci._id === item._id);
        if (alreadyInCart) {
          return;
        }
        state.cartItems = [...state.cartItems, item];
      }

      savePartnerCartToStorage(state.cartItems);
    },
    removeFromPartnerCart: (state, action) => {
      const itemId = action.payload;
      state.cartItems = state.cartItems.filter(item => item._id !== itemId);
      savePartnerCartToStorage(state.cartItems);
    },
    clearPartnerCart: (state) => {
      state.cartItems = [];
      savePartnerCartToStorage(state.cartItems);
    },
  },
});

export const { addToPartnerCart, removeFromPartnerCart, clearPartnerCart } = partnerCartSlice.actions;

// Selectors
export const selectPartnerCartItems = (state) => state.partnerCart.cartItems;
export const selectPartnerCartTotal = (state) =>
  state.partnerCart.cartItems.reduce((total, item) => total + (item.price || 0), 0);
export const selectPartnerCartItemCount = (state) => state.partnerCart.cartItems.length;

export default partnerCartSlice.reducer;
